import React from 'react';
import { motion } from 'framer-motion';
import { contracts } from '../data/mock';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiFileText } from 'react-icons/fi';

const Contracts = () => {
  const lanes = [
    { id: 'critical', title: '< 30 Days (Critical)', filter: c => c.expiry <= 30, color: 'border-red-500/50 bg-red-500/5' },
    { id: 'warning', title: '30 - 90 Days', filter: c => c.expiry > 30 && c.expiry <= 90, color: 'border-yellow-500/50 bg-yellow-500/5' },
    { id: 'safe', title: '> 90 Days', filter: c => c.expiry > 90, color: 'border-emerald-500/50 bg-emerald-500/5' }
  ];

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-8 max-w-7xl mx-auto h-[calc(100vh-5rem)] flex flex-col">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white">Renewal Lanes</h1>
        <p className="text-slate-400 mt-1">Kanban view of upcoming contract expirations.</p>
      </div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-6 overflow-hidden">
        {lanes.map(lane => {
          const laneContracts = contracts.filter(lane.filter).sort((a,b) => a.expiry - b.expiry);
          return (
            <div key={lane.id} className={`flex flex-col rounded-xl border ${lane.color} p-4 h-full overflow-hidden`}>
              <div className="flex justify-between items-center mb-4">
                <h3 className="font-bold text-slate-200">{lane.title}</h3>
                <span className="bg-[#0A0F1C] text-slate-400 text-xs px-2 py-1 rounded-full border border-slate-700">
                  {laneContracts.length}
                </span>
              </div>
              
              <div className="flex-1 overflow-y-auto space-y-4 pr-2 custom-scrollbar">
                {laneContracts.map(contract => (
                  <motion.div 
                    layoutId={contract.id}
                    key={contract.id} 
                    className="bg-[#0F1626] border border-slate-800 p-4 rounded-lg shadow-lg cursor-grab hover:border-slate-600 transition-colors"
                  >
                    <div className="flex justify-between items-start mb-3">
                      <div className="bg-slate-800 p-2 rounded text-slate-300">
                        <SafeIcon icon={FiFileText} />
                      </div>
                      <div className="flex items-center gap-1 text-xs font-bold bg-[#0A0F1C] px-2 py-1 rounded text-slate-300 border border-slate-800">
                        <SafeIcon icon={FiClock} className={contract.expiry <= 30 ? 'text-red-400' : 'text-slate-400'} />
                        <span className={contract.expiry <= 30 ? 'text-red-400' : ''}>{contract.expiry}d</span>
                      </div>
                    </div>
                    <h4 className="font-bold text-white text-sm mb-1">{contract.vendor}</h4>
                    <p className="text-xs text-slate-400 mb-4">{contract.type}</p>
                    
                    <div className="flex justify-between items-center pt-3 border-t border-slate-800">
                      <span className="text-xs font-mono text-slate-300">{contract.id}</span>
                      <span className="text-sm font-bold text-yellow-400">{contract.value}</span>
                    </div>
                  </motion.div>
                ))}
                {laneContracts.length === 0 && (
                  <div className="h-32 border-2 border-dashed border-slate-800 rounded-lg flex items-center justify-center text-slate-500 text-sm">
                    No contracts in this lane
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default Contracts;